import { api } from '@bilibili-maoer/web-utils';
import { getFetch } from '../../utils/fetcher.js';
import '@babel/runtime-corejs3/core-js/instance/concat';

/* eslint-disable no-magic-numbers */

var SEARCH_TYPE_MAP = {
  ALL: 3,
  USER: 1,
  ALBUM: 2,
  CV: 4,
  DRAMA: 5,
  FM: 6,
  CHANNEL: 8
};
var getSoundSearchSuggest = function getSoundSearchSuggest(s, type) {
  return getFetch({
    url: "".concat(api.MISSEVAN_API_PREFIX_URL, "/sound/suggest"),
    params: {
      s: s,
      type: type ? SEARCH_TYPE_MAP[type] : SEARCH_TYPE_MAP.ALL
    }
  });
};

export { getSoundSearchSuggest };
